import { Component, NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules, NoPreloading } from '@angular/router';
import { IndexComponent } from './main/index/index.component';
import { QuienesSomosComponent } from './main/quienes-somos/quienes-somos.component';
import { ServiciosComponent } from './main/servicios/servicios.component';
import { SaludComponent } from './main/salud/salud.component';
import { EstadisticasComponent } from './main/estadisticas/estadisticas.component';
import { ConsultasPorEstadoComponent } from './main/consultas-por-estado/consultas-por-estado.component';
import { SimposiosComponent } from './main/simposios/simposios.component';
import { SimposioComponent } from './main/simposio/simposio.component';
import { NotasComponent } from './main/notas/notas.component';
import { NotaComponent } from './main/nota/nota.component';
import { DirectorioComponent } from './main/directorio/directorio.component';
import { ContactoComponent } from './main/contacto/contacto.component';
import { EmpleoComponent } from './main/empleo/empleo.component';
import { AvisoDePrivacidadComponent } from './main/aviso-de-privacidad/aviso-de-privacidad.component';
import { AvisoLegalComponent } from './main/aviso-legal/aviso-legal.component';
import { ConsultoriosComponent } from './main/consultorios/consultorios.component';
import { ConsultoriosDentalesComponent } from './main/consultorios-dentales/consultorios-dentales.component';
import { LigasGrupoPorUnPaisMejorComponent} from './main/ligas-grupo-por-un-pais-mejor/ligas-grupo-por-un-pais-mejor.component';
import { ConsultoriosNutricionalesComponent } from './main/consultorios-nutricionales/consultorios-nutricionales.component';
import { LigasSaludComponent } from './main/ligas-salud/ligas-salud.component';
import { RegistroComponent } from './main/licitaciones/registro/registro.component';
import { LoginComponent } from './main/licitaciones/login/login.component';
import { ListadoOfertasComponent } from './main/licitaciones/listado-ofertas/listado-ofertas.component';
import { ListadoProveedorComponent } from './main/licitaciones/listado-proveedor/listado-proveedor.component';
import { ActualizacionRegistroComponent } from './main/licitaciones/actualizacion-registro/actualizacion-registro.component';
import { ActualizacionContrasenaComponent } from './main/licitaciones/actualizacion-contrasena/actualizacion-contrasena.component';
import { RecuperarContrasenaComponent } from './main/licitaciones/recuperar-contrasena/recuperar-contrasena.component';
import { LoginAdminComponent } from './main/licitaciones/administrador/login-admin/login-admin.component';
import { FamiliasComponent } from './main/licitaciones/administrador/familias/familias.component';
import { CalificacionComponent } from './main/licitaciones/administrador/calificacion/calificacion.component';
import { OfertasDeLicitacionComponent } from './main/licitaciones/administrador/ofertas-de-licitacion/ofertas-de-licitacion.component';
import { ConsultasReportesComponent } from './main/licitaciones/administrador/consultas-reportes/consultas-reportes.component';
import { PostulanteslicitacionComponent } from './main/licitaciones/administrador/postulanteslicitacion/postulanteslicitacion.component'
import {ConsultoriosPsicologicosComponent } from './main/consultorios-psicologicos/consultorios-psicologicos.component'
import { ConsultoriosEspecialidadesComponent } from './main/consultorios-especialidades/consultorios-especialidades.component';
import { CookiesComponent } from './main/cookies/cookies.component';

const routes: Routes = [
  {path:'',component:IndexComponent},
  {path:'quienes-somos',component:QuienesSomosComponent},
  {path:'servicios',component:ServiciosComponent},
  {path:'salud',component:SaludComponent},
  {path:'estadisticas',component:EstadisticasComponent},
  {path:'consultas-por-estado',component:ConsultasPorEstadoComponent},
  {path:'simposios',component:SimposiosComponent},
  {path:'simposio/:id/:urlNota',component:SimposioComponent},
  {path:'notas',component:NotasComponent},
  {path:'nota/:urlNota',component:NotaComponent},
  {path:'directorio',component:DirectorioComponent},
  {path:'contacto',component:ContactoComponent},
  {path:'empleo',component:EmpleoComponent},
  {path:'aviso-de-privacidad',component:AvisoDePrivacidadComponent},
  {path:'aviso-legal',component:AvisoLegalComponent},
  {path:'consultorios',component:ConsultoriosComponent},
  {path:'consultorios-dentales',component:ConsultoriosDentalesComponent},
  {path:'ligas-grupo-por-un-pais-mejor',component:LigasGrupoPorUnPaisMejorComponent},
  {path:'consultorios-nutricionales',component:ConsultoriosNutricionalesComponent},
  {path:'consultorios-especialidades',component:ConsultoriosEspecialidadesComponent},
  {path:'ligas-salud',component:LigasSaludComponent},
  {path:'licitaciones/registro',component:RegistroComponent},
  {path:'licitaciones/login',component:LoginComponent},
  {path:'licitaciones/listado-ofertas',component:ListadoOfertasComponent},
  {path:'licitaciones/listado-proveedor',component:ListadoProveedorComponent},
  {path:'licitaciones/actualizacion-registro',component:ActualizacionRegistroComponent},
  {path:'licitaciones/actualizacion-contrasena',component:ActualizacionContrasenaComponent},
  {path:'licitaciones/recuperar-contrasena',component:RecuperarContrasenaComponent},
  {path:'licitaciones/administrador/login',component:LoginAdminComponent},
  {path:'licitaciones/administrador/familias',component:FamiliasComponent},
  {path:'licitaciones/administrador/calificacion',component:CalificacionComponent},
  {path:'licitaciones/administrador/ofertas-de-licitacion',component:OfertasDeLicitacionComponent},
  {path:'licitaciones/administrador/consultas-reportes',component:ConsultasReportesComponent},
  {path:'licitaciones/administrador/postulantes-ofertas',component:PostulanteslicitacionComponent},
  {path:'consultorios-psicologicos',component:ConsultoriosPsicologicosComponent},
  {path:'politica-de-cookies',component:CookiesComponent},
  {path: '**', pathMatch: 'full', redirectTo: ''},
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "enabled",
      preloadingStrategy: NoPreloading
    })
  ],
  exports: [RouterModule]
})

export class AppRoutingModule { }
